export const sexOptions = ['Male', 'Female', 'Other'];
export const relationOptions = ['Self', 'Child', 'Spouse', 'Other'];
export const emergencyContactOptions = ['Parent', 'Spouse', 'Other'];
